import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginWatcher } from "../../redux/actions/loginactioncreators";
import { TextField } from "../fields/TextField";
import { FormattedMessage } from "react-intl";
import flowStages from "../../flowStages";
import { NewFADVLoginForm } from "../login/NewFADVLoginForm";

export const ConfirmEmailAddress = () => {
  const dispatch = useDispatch();
  // useIntl is not needed, remove unused variable
  const username = useSelector(state => state.loginForm.username);
  const password = useSelector(state => state.loginForm.password);
  const challenge = useSelector(state => state.loginForm.challenge);
  const destination = challenge?.challengeParameters?.["DESTINATION"];

  const handleSubmit = (formData, _errors) => {
    const code = formData.confirmEmailAddress;
    dispatch(loginWatcher({
      flowStage: flowStages.VERIFY_EMAIL,
      username,
      password,
      challengeResponse: {
        session: challenge.session,
        challengeName: challenge.challengeName,
        challengeParameters: {
          USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
          CODE: code,
        }
      }
    }));
  };

  return (
    <NewFADVLoginForm
      requiredFields={["confirmEmailAddress"]}
      onSubmit={handleSubmit}
      submitButtonText={
        <FormattedMessage
          id="login.confirmEmailSubmit"
          defaultMessage="Confirm Email"
          description="Button text for submitting email confirmation code"
        />
      }
    >
      <div className="text-base">
        <FormattedMessage
          id="login.confirmEmailBlurb"
          defaultMessage="An email was sent to {destination} with a verification code. Please type it into the input below to confirm your email address."
          description="Blurb shown to user explaining that a verification code was sent to their email address."
          values={{ destination }}
        />
      </div>
      <TextField
        id="confirmEmailAddress"
        name="confirmEmailAddress"
        autoFocus={true}
        label={
          <FormattedMessage
            id="login.emailAddressConfirmationCode"
            defaultMessage="Confirmation Code"
            description="Label for the confirmation code input field in email verification form"
          />
        }
      />
    </NewFADVLoginForm>
  );
};
